
export const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  internalApiKey: process.env.REACT_APP_INTERNAL_API_KEY,
}
